import { render, staticRenderFns } from "./ChoosePresentation.vue?vue&type=template&id=140394ae&"
import script from "./ChoosePresentation.vue?vue&type=script&lang=js&"
export * from "./ChoosePresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports